import getIdTokenCookie from './cookies/getIdTokenCookie';
export const getUserUuid = (idToken)=>{
    const jwt = getIdTokenCookie() || idToken;
    if (!jwt) {
        return undefined;
    }
    return isoParseIdTokenJWT(jwt)?.sub;
};
export function isoParseIdTokenJWT(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        if (typeof window !== 'undefined') return JSON.parse(window.atob(base64));
        return JSON.parse(Buffer.from(base64, 'base64').toString());
    } catch  {
        return undefined;
    }
}
